import { useQuery } from '@tanstack/react-query'
import { fetchSubService } from '../api'

export function useSubServiceData(slug, subSlug) {
  return useQuery({
    queryKey: ['subservice', slug, subSlug],
    queryFn: () => fetchSubService(slug, subSlug),
    enabled: !!slug && !!subSlug,
    staleTime: 30_000,
  })
}
